import React from 'react';
import FloatingShapes from "../common/FloatingShapes";

interface TimeSlotData {
  readonly time: string;
  readonly label: string;
  readonly age6to10: readonly string[];
  readonly age11to14: readonly string[];
  readonly age15to18: readonly string[];
}

interface DayData {
  readonly day: number;
  readonly title: string;
  readonly subtitle: string;
  readonly dark: boolean;
  readonly timeSlots: readonly TimeSlotData[];
}

const trackTypes = [
  { label: "Чөлөөт хөтөлбөртэй ээлж", color: "bg-secondary-500" },
  { label: "Сонирхолтой шинжлэх ухаан ээлж", color: "bg-accent-500" },
  { label: "Байгаль экологид суралцья ээлж", color: "bg-emerald-500" },
] as const;

const days: readonly DayData[] = [
  {
    day: 1,
    title: "1-р өдөр",
    subtitle: "ТАНИЛЦАХ ӨДӨР",
    dark: false,
    timeSlots: [
      {
        time: "10:00-12:30",
        label: "ИХ ҮДИЙН ХӨТӨЛБӨР",
        age6to10: ["Танилцах тойрог тоглоом, нэрийн наадам", "\"Би хэн бэ?\" мэдрэхүйн туршилт", "Байгаль ажиглах алхалт"],
        age11to14: ["Баг бүрдүүлэх challenge", "Тархины сонирхолтой сорил", "Ургамал таних"],
        age15to18: ["Ice-breaking, манлайллын тоглоом", "Хувийн зан төлөв тодорхойлох тест", "Экосистемийн зураглал хийх"],
      },
      {
        time: "17:00-18:30",
        label: "БАГА ҮДИЙН ХӨТӨЛБӨР",
        age6to10: ["Чөлөөт сонголтын хөтөлбөрүүд, Тоглоомын тойрог", "Энгийн туршилт (ус, агаар), STEAM тоглоом", "Хог ангилах тоглоом"],
        age11to14: ["Төсөлт хөтөлбөрүүд, Байгалийн аялал", "Лего ровот угсрах, VR контент", "Эко боловсрол өртөөчилсөн хөтөлбөр"],
        age15to18: ["Спорт тоглоомууд, Бүлэг дундын уулзалт", "Инженерийн challenge, Пуужин хийж хөөргөх", "Байгаль хамгаалах хэлэлцүүлэг, Ойн адал явдалт хөтөлбөр"],
      },
      {
        time: "20:00-21:30",
        label: "ОРОЙН ХӨТӨЛБӨР",
        age6to10: ["Үлгэрийн цаг", "Од харах", "Сонирхолтой амьтад - happy time"],
        age11to14: ["Авьяаслаг үдэш", "Одон орон сонирхол", "Байгалийн тухай түүх"],
        age15to18: ["Talent show", "Орчлон ертөнцийн хэлэлцүүлэг", "Түүдгийн дэргэдэх үдэш"],
      },
    ],
  },
  {
    day: 2,
    title: "2-р өдөр",
    subtitle: "СУРАЛЦАХ БА НЭЭХ",
    dark: true,
    timeSlots: [
      {
        time: "10:00-12:30",
        label: "ИХ ҮДИЙН ХӨТӨЛБӨР",
        age6to10: ["Бүтээлч гар урлал", "Өнгө холих туршилт", "Амьтны мөр таних"],
        age11to14: ["DIY төсөл", "Хими туршилт", "Биологийн ажиглалт"],
        age15to18: ["Startup санаа", "Судалгааны жижиг төсөл", "Экологийн судалгаа"],
      },
      {
        time: "17:00-18:30",
        label: "БАГА ҮДИЙН ХӨТӨЛБӨР",
        age6to10: ["Усны тоглоом", "Соронз туршилт", "Мод тарих"],
        age11to14: ["Adventure game", "Физикийн тоглоом", "Байгаль хамгаалах ажил"],
        age15to18: ["Extreme challenge", "Роботик танилцуулга", "Эко сайн дурын ажил"],
      },
      {
        time: "20:00-21:30",
        label: "ОРОЙН ХӨТӨЛБӨР",
        age6to10: ["Кино үдэш", "Шинжлэх ухааны шоу", "Оддын зураг зурах"],
        age11to14: ["Сэдэвт кино хэлэлцүүлэг", "Туршилтын үзүүлбэр", "Шөнийн байгаль ажиглах"],
        age15to18: ["Debate night", "TED-style илтгэл", "Байгаль-фото шөнийн ан"],
      },
    ],
  },
  {
    day: 3,
    title: "3-р өдөр",
    subtitle: "ХӨГЖИХ БА ДҮГНЭХ",
    dark: false,
    timeSlots: [
      {
        time: "10:00-12:30",
        label: "ИХ ҮДИЙН ХӨТӨЛБӨР",
        age6to10: ["Багийн тоглоом", "Таавар бодох", "Байгальд зураг зурах"],
        age11to14: ["Treasure hunt", "Логик бодлого", "Эко постер"],
        age15to18: ["Leadership challenge", "Шийдвэр гаргалт", "Тогтвортой хөгжил төсөл"],
      },
      {
        time: "17:00-18:30",
        label: "БАГА ҮДИЙН ХӨТӨЛБӨР",
        age6to10: ["Хөгжөөнт тэмцээн", "Туршилтын үзэсгэлэн", "Цэвэрлэгээ"],
        age11to14: ["Багийн уралдаан", "ШУ танилцуулга", "Байгаль хамгаалах аян"],
        age15to18: ["Спорт финал", "Судалгааны хамгаалалт", "Эко тайлан"],
      },
      {
        time: "20:00-21:30",
        label: "ОРОЙН ХӨТӨЛБӨР",
        age6to10: ["Хаалтын баяр", "Сонирхолтой баримт", "Сэтгэл хуваалцах тойрог"],
        age11to14: ["Авьяаслаг үдэш", "Quiz night", "Байгальд талархал"],
        age15to18: ["Gala night", "Оюуны тэмцээн", "Reflection session"],
      },
    ],
  },
];

const timeAllocation = [
  { label: "Хөгжлийн хөтөлбөр", perDay: "6 цаг/өдөр", total: "18 цаг нийт" },
  { label: "Хооллох", perDay: "5 цаг/өдөр", total: "15 цаг нийт" },
  { label: "Чөлөөт цаг", perDay: "5 цаг/өдөр", total: "15 цаг нийт" },
  { label: "Нийт", perDay: "16 цаг/өдөр", total: "48 цаг" },
] as const;

const features = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
      </svg>
    ),
    title: "Насны бүлэг тус бүрт тохирсон",
    description: "6-10, 11-14, 15-18 насны бүлэг тус бүрт зориулсан тусгай хөтөлбөрүүд",
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a23.838 23.838 0 0 0-2.688 6.41c4.295 2.056 7.87 4.93 10.478 8.443a32.648 32.648 0 0 1 10.478-8.443 23.839 23.839 0 0 0-2.688-6.41m-15.482 0A23.94 23.94 0 0 1 12 3.75a23.94 23.94 0 0 1 7.741 6.397" />
      </svg>
    ),
    title: "Танин мэдэхүй + хөгжүүлэлт + амралт хослуулсан",
    description: "Суралцах, хөгжих, амрах гурвыг зөв хослуулсан цогц хөтөлбөр",
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
      </svg>
    ),
    title: "STEAM + Эко боловсрол + Soft skills",
    description: "Шинжлэх ухаан, технологи, байгаль экологи, хувь хүний ур чадварыг хөгжүүлэх",
  },
] as const;

const trackColors = [
  "bg-secondary-100 text-secondary-700 border-secondary-200",
  "bg-accent-100 text-accent-700 border-accent-200",
  "bg-emerald-100 text-emerald-700 border-emerald-200",
] as const;

const trackColorsDark = [
  "bg-secondary-900/30 text-secondary-300 border-secondary-700/50",
  "bg-accent-900/30 text-accent-300 border-accent-700/50",
  "bg-emerald-900/30 text-emerald-300 border-emerald-700/50",
] as const;

const ageGroups = ["6-10 нас", "11-14 нас", "15-18 нас"] as const;

function TimeSlotCard({ slot, dark }: { readonly slot: TimeSlotData; readonly dark: boolean }) {
  const colors = dark ? trackColorsDark : trackColors;
  const activities = [slot.age6to10, slot.age11to14, slot.age15to18];

  return (
    <div className={`rounded-2xl border ${dark ? 'border-white/10 bg-white/5' : 'border-neutral-200 bg-white'} overflow-hidden`}>
      <div className={`px-6 py-4 ${dark ? 'bg-white/5 border-b border-white/10' : 'bg-neutral-50 border-b border-neutral-200'}`}>
        <div className="flex items-center gap-3">
          <span className={`inline-flex items-center justify-center w-10 h-10 rounded-xl ${dark ? 'bg-secondary-500/20 text-secondary-300' : 'bg-secondary-100 text-secondary-600'} font-bold text-sm`}>
            {slot.time.split('-')[0]}
          </span>
          <div>
            <h4 className={`font-bold ${dark ? 'text-white' : 'text-neutral-900'}`}>{slot.label}</h4>
            <p className={`text-sm ${dark ? 'text-slate-400' : 'text-neutral-500'}`}>{slot.time}</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6">
        {ageGroups.map((age, idx) => (
          <div key={age}>
            <div className={`text-xs font-bold uppercase tracking-wider mb-3 ${dark ? 'text-slate-400' : 'text-neutral-500'}`}>
              {age}
            </div>
            <div className="space-y-2">
              {activities[idx].map((activity, aIdx) => (
                <div
                  key={aIdx}
                  className={`rounded-lg border px-3 py-2 text-sm ${colors[aIdx]}`}
                >
                  {activity}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function DaySection({ dayData }: { readonly dayData: DayData }) {
  const { day, title, subtitle, dark, timeSlots } = dayData;

  return (
    <div className={dark ? 'bg-primary-800 relative' : 'bg-white'}>
      {dark && (
        <>
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/10 blur-[120px]" />
            <div className="absolute bottom-20 left-1/4 w-[300px] h-[300px] rounded-full bg-accent-500/8 blur-[100px]" />
          </div>
          <FloatingShapes variant="sparse" />
        </>
      )}
      <div className={`relative py-16 sm:py-20 ${dark ? '' : ''}`}>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold mb-4 ${
              dark
                ? 'border border-white/10 bg-white/5 text-secondary-300'
                : 'border border-secondary-200 bg-secondary-50 text-secondary-600'
            }`}>
              {title}
            </div>
            <h2 className={`text-3xl sm:text-4xl font-extrabold tracking-tight ${
              dark ? 'text-white' : 'text-neutral-900'
            }`}>
              <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">
                {subtitle}
              </span>
            </h2>
          </div>

          <div className="space-y-6">
            {timeSlots.map((slot, idx) => (
              <TimeSlotCard key={idx} slot={slot} dark={dark} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ThreeDayProgram() {
  return (
    <>
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-400/10 blur-[100px]" />
          <div className="absolute bottom-20 right-1/4 w-[250px] h-[250px] rounded-full bg-accent-500/10 blur-[80px]" />
        </div>
        <FloatingShapes variant="default" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-secondary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              Бүтээгдэхүүн, үйлчилгээ
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight">
              <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">
                3 хоногийн хөтөлбөр
              </span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
              ОЛОН УЛСЫН ХҮҮХДИЙН НАЙРАМДАЛ ЦОГЦОЛБОРЫН 3 ӨДРИЙН ҮЛГЭРЧИЛСЭН ХӨТӨЛБӨР
            </p>
          </div>
        </div>
      </div>

      {/* Track Types Section */}
      <div className="bg-white py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-neutral-900 mb-2">
              Хөтөлбөрийн чиглэлүүд
            </h2>
            <p className="text-neutral-500">3 төрлийн ээлж тус бүрт зориулсан хөтөлбөрүүд</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            {trackTypes.map((track, idx) => (
              <div
                key={idx}
                className="inline-flex items-center gap-3 rounded-2xl bg-neutral-50 border border-neutral-200 px-6 py-4 shadow-sm hover:shadow-md transition-shadow"
              >
                <span className={`w-4 h-4 rounded-full ${track.color}`} />
                <span className="font-semibold text-neutral-800">{track.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Day Sections */}
      {days.map((dayData) => (
        <DaySection key={dayData.day} dayData={dayData} />
      ))}

      {/* Time Allocation Table */}
      <div className="relative bg-primary-800">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-20 left-1/3 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[120px]" />
          <div className="absolute bottom-10 right-1/4 w-[300px] h-[300px] rounded-full bg-accent-500/8 blur-[100px]" />
        </div>
        <FloatingShapes variant="alt" />
        <div className="relative py-16 sm:py-20">
          <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight">
                <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">
                  Цаг хуваарилалт
                </span>
              </h2>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm overflow-hidden">
              <div className="grid grid-cols-3 gap-px bg-white/10">
                <div className="bg-white/10 px-6 py-4 text-sm font-bold text-secondary-300 uppercase tracking-wider">
                  Хөтөлбөр
                </div>
                <div className="bg-white/10 px-6 py-4 text-sm font-bold text-secondary-300 uppercase tracking-wider text-center">
                  Өдрийн
                </div>
                <div className="bg-white/10 px-6 py-4 text-sm font-bold text-secondary-300 uppercase tracking-wider text-center">
                  Нийт
                </div>
              </div>
              {timeAllocation.map((row, idx) => {
                const isLast = idx === timeAllocation.length - 1;
                return (
                  <div
                    key={idx}
                    className={`grid grid-cols-3 gap-px ${
                      isLast ? 'bg-secondary-500/20' : idx % 2 === 0 ? 'bg-white/[0.02]' : ''
                    } ${!isLast ? 'border-b border-white/5' : ''}`}
                  >
                    <div className={`px-6 py-4 ${isLast ? 'font-bold text-white' : 'text-slate-300'}`}>
                      {row.label}
                    </div>
                    <div className={`px-6 py-4 text-center ${isLast ? 'font-bold text-white' : 'text-slate-400'}`}>
                      {row.perDay}
                    </div>
                    <div className={`px-6 py-4 text-center ${isLast ? 'font-bold text-secondary-300' : 'text-slate-400'}`}>
                      {row.total}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Feature Highlights */}
      <div className="bg-neutral-50 py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-neutral-900">
              Хөтөлбөрийн онцлог
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 p-8 text-center"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-secondary-500 to-accent-500 text-white mb-6">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-3">{feature.title}</h3>
                <p className="text-neutral-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
